import { RootState } from '@atredux/store'
import {
    ISubzone,
    IZone,
    IZoneState,
} from '@atredux/slices/zoneSlice'

export const getZoneInfo = (state: RootState): IZoneState => state.zone
export const getCurrentZoneDisplay = (state: RootState): string => state.zone.currentZoneDisplay
export const getZoneDetails = (state: RootState): IZone => state.zone.zone
export const getSubzoneDetails = (state: RootState): ISubzone => state.zone.subzone
export const getZone = (state: RootState): string => state.zone.zoneName
export const getSubzone = (state: RootState): string => state.zone.subzoneName
